var map = {
	"./arrow-down.svg": 5522,
	"./book.svg": 7229,
	"./card-logo-vip.svg": 6670,
	"./copy.svg": 1141,
	"./dateAsc.svg": 3321,
	"./dateDesc.svg": 8493,
	"./download.svg": 4038,
	"./icon-add.svg": 2167,
	"./icon-alert.svg": 5900,
	"./icon-card-brigadier.svg": 8530,
	"./icon-card.svg": 6940,
	"./icon-check.svg": 9754,
	"./icon-checkbox.svg": 9689,
	"./icon-close.svg": 7318,
	"./icon-construction.svg": 8545,
	"./icon-copy.svg": 3297,
	"./icon-de.svg": 9611,
	"./icon-emoji-happy-vip.svg": 5019,
	"./icon-emoji-happy.svg": 3949,
	"./icon-logo-impotant.svg": 5814,
	"./icon-logo.svg": 3755,
	"./icon-other.svg": 7228,
	"./icon-qr-code.svg": 6607,
	"./icon-ring.svg": 4,
	"./icon-search.svg": 2058,
	"./icon-share.svg": 3471,
	"./icon-stats-down.svg": 5652,
	"./icon-stats-up.svg": 9759,
	"./icon-status-active.svg": 192,
	"./icon-status-deactive.svg": 6850,
	"./icon-status-off.svg": 484,
	"./icon-status-on.svg": 9774,
	"./lang-de.svg": 7162,
	"./lang-en.svg": 8114,
	"./lang-ru.svg": 6132,
	"./link.svg": 6526,
	"./logo-iedn.svg": 6412,
	"./logo-vpn.svg": 2232,
	"./share.svg": 4971
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2871;